import { clearSession } from './session';

let isInterceptorInstalled = false;

export function setupGlobalFetchAuthInterceptor() {
  if (isInterceptorInstalled) {
    return;
  }

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401) {
      clearSession();
      window.location.reload();
    }

    return response;
  };

  isInterceptorInstalled = true;
}